import Image from "next/image";
import Link from "next/link";
import React from "react";
import ReactPlayer from "react-player";
import { generateSlugWithId } from "src/app/serverUtils";

export interface AnnouncementCardProps {
  title: string;
  id?: string | number | undefined;
  description: string;
  image: string;
  buttonText?: string;
  videoLink?: string;
  createdAt?: string;
  className?: string;
}

export const placeholderBlur =
  "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMSIgaGVpZ2h0PSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB3aWR0aD0iMSIgaGVpZ2h0PSIxIiBmaWxsPSIjZTBkMGQwIi8+Cjwvc3ZnPg==";

export const isYouTube = (url?: string) =>
  url && (url.includes("youtube.com") || url.includes("youtu.be"));

export const isBitChute = (url?: string) => url && url.includes("bitchute.com");

export const AnnouncementCard: React.FC<
  AnnouncementCardProps & { className?: string }
> = ({ title, description, image, id, className, videoLink }) => {

  const hasImage = Boolean(image) && image !== "/images/not-found-2.webp";
  const hasVideo = !hasImage && Boolean(videoLink);
  const slugwithid = generateSlugWithId(Number(id), title);

  return (
    <Link
      href={`/announcements/${slugwithid}`}
      className={`w-[350px] xsm:w-[250px] block text-secondary-main overflow-hidden rounded-lg ${className}`}
    >
      <div className="w-full h-[14rem] relative rounded-t-sm overflow-hidden">
        {hasImage ? (
          <Image
            height={300}
            width={300}
            loading="lazy"
            src={image!}
            alt={title}
            className="w-full h-full object-cover"
            placeholder="empty"
          />
        ) : hasVideo && isYouTube(videoLink) ? (
          <ReactPlayer
            url={videoLink}
            width="100%"
            height="100%"
            controls
            style={{ objectFit: "cover" }}
          />
        ) : hasVideo && isBitChute(videoLink) ? (
          <iframe
            width="100%"
            height="100%"
            src={videoLink?.replace("/video/", "/embed/")}
            title={title}
            allowFullScreen
            className="w-full h-full"
          ></iframe>
        ) : (
          <Image
            height={300}
            width={300}
            loading="lazy"
            src="/images/not-found-2.webp"
            alt="No preview available"
            className="w-full h-full object-cover"
            placeholder="blur"
            blurDataURL={placeholderBlur}
          />
        )}
      </div>

      <div className="py-4">
        <h3 className="font-bold h5 mb-2 overflow-hidden text-ellipsis whitespace-nowrap">
          {title}
        </h3>
        <p
          className="text-sm"
          dangerouslySetInnerHTML={{
            __html:
              description.length > 250
                ? `${description.slice(0, 250)}...`
                : description,
          }}
        />
      </div>
    </Link>
  );
};

export default AnnouncementCard;
